import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class SiteReviewOpSignaturesCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        API.Certification.get('/query/getSiteReviewOpSignatures', {},
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.description, value: item.siteReviewOpSignaturesId } })
                    });                    
                }
            },
            { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Please select number of Signatures here..."}
                items={this.state.items}
                searchable={false}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default SiteReviewOpSignaturesCombo;

// Mark this as a form component
SiteReviewOpSignaturesCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/siteReviewOpSignaturesCombo/SiteReviewOpSignaturesCombo.js